<template>
  <SwipeDialog
    class="doctor-list-select-dialog"
    title="医生选择"
    @closeFn="$emit('close')"
  >
    <component
      :is="currentListComponent"
      class="doctor-list-select-content"
      :on-select-item="handleSelectItem"
      :selected-items="selectedIdList"
    />
    <div class="doctor-list-select-footer">
      <van-button
        type="info"
        block
        round
        class="doctor-list-confirm-button"
        @click="handleConfirm"
      >确定</van-button>
    </div>
  </SwipeDialog>
</template>

<script>
import DoctorList from '@/components/DoctorTargetList.vue';
import GbaDoctorList from '@/views/gba/list.vue';
import SwipeDialog from '@/views/layout/swipeDialog';
import {Button} from 'vant';
import Vue from 'vue';
import { isGBA } from '@/utils/index';

Vue.use(Button);

export default {
  components: {
    DoctorList,
    GbaDoctorList,
    SwipeDialog,
  },
  props: {
    multipleMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      selectedList: [],
      tabIndex: 0,
    };
  },
  computed: {
    selectedIdList() {
      return this.selectedList.map((item) => item.physician_id);
    },
    currentListComponent() {
      return isGBA() ? 'GbaDoctorList' : 'DoctorList';
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('select', this.selectedList);
    },
    handleSelectItem(item) {
      const id = item.physician_id;

      if (this.multipleMode) {
        const selectedIndex = this.selectedList.findIndex(
          (item) => item.physician_id === id,
        );

        if (selectedIndex > -1) {
          this.selectedList.splice(selectedIndex, 1);
        } else {
          this.selectedList.push(item);
        }
      } else {
        this.selectedList = [item];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.doctor-list-select-dialog ::v-deep .card-header-row {
  background: transparent !important;
  box-shadow: none !important;
}

.doctor-list-select-content {
  padding-bottom: 72px;
}

.doctor-list-select-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  padding: 9px 16px calc(9px + env(safe-area-inset-bottom));
  border-top: 1px solid rgba(31, 35, 40, 0.06);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -4px 16px rgba(31, 35, 40, 0.06);
  backdrop-filter: blur(8px);
}

.doctor-list-confirm-button {
  height: 42px;
  border: 0;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(170, 52, 27, 0.18);
}
</style>
